import * as Sentry from "@sentry/react";

if (process.env.MIX_APP_ENV === 'production') {
    Sentry.init({
        dsn: "https://4bc433c70ce9f25d4685be35c2897fa8@o4508200659648512.ingest.de.sentry.io/4508200664236112",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["https://deepsy.fr", "https://www.deepsy.fr", "https://go.deepsy.fr", "https://qa.deepsy.fr"],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

export default Sentry;